import React from 'react'
import {Link} from 'react-router-dom'
import {auth} from '../firebase'
import{useNavigate} from 'react-router-dom'
function NavBar({user}) {
    const history = useNavigate()
  return (
    <div>
    <nav>
    <div className="nav-wrapper blue">
      <Link to="/" className="brand-logo left" style={{marginLeft:'1%'}}>Todo</Link>
      <ul id="nav-mobile" className="right">
          {
          user!==null ?
            <li>
                <button className='btn red' onClick={()=>{
                    auth.signOut()
                    history('/login')
                }}>Logout</button>
            </li>
            :<>
            <li><Link to="/login">Login</Link></li>
            <li><Link to="/signup">SignUp</Link></li>
            </>
        }
      </ul>
    </div>
  </nav>
    </div>
  )
}

export default NavBar